import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Advantages, EXPLORER_URL, Intro, Section } from 'shared';

import { BOTTOM_TEXT, intro, list } from './constants';

export const Explorer = () => {
  return (
    <>
      <Intro
        mainTitle="Explorer"
        paragraph={
          <>
            {intro.paragraph}
            <br />
            <Button LinkComponent="a" target="_blank" href={EXPLORER_URL} sx={{ mt: 3 }}>
              Open Explorer
            </Button>
          </>
        }
        paragraphProps={{ letterSpacing: '-0.4px !important' }}
        sx={{ h1: { maxWidth: 1000 } }}
      />
      <Advantages list={list} />
      <Section>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(12, 1fr)',
            mt: { xs: 2, sm: 3.5 },
          }}
        >
          <Typography
            variant="h6"
            sx={{
              gridColumn: { xs: 'span 12', md: '5 / 13' },
            }}
          >
            {BOTTOM_TEXT}
          </Typography>
        </Box>
      </Section>
    </>
  );
};
